import { pageIdToRouteMapping } from 'src/app/routes/pageIdToRouteMapping';
import { createFlowPageIds } from 'src/app/shared/constants/pageUid';

export const getRouteByPageUid = (pageUid: string) =>
  pageIdToRouteMapping[pageUid];

export const getNextRouteByPageUid = (pageUid: string) => {
  const index = createFlowPageIds.findIndex(
    (value: string) => value === pageUid,
  );
  const newPageId = createFlowPageIds[index + 1];
  return getRouteByPageUid(newPageId);
};
